import { format, formatDistanceToNowStrict, isToday, isPast, parseISO } from "date-fns";
import { cs } from "date-fns/locale";

const toDate = (v) => (v ? (typeof v === "string" ? parseISO(v) : v) : null);

export const fmtDate = (v) => { const d = toDate(v); return d ? format(d, "d.M.yyyy", { locale: cs }) : "—"; };
export const fmtDateTime = (v) => { const d = toDate(v); return d ? format(d, "d.M.yyyy HH:mm", { locale: cs }) : "—"; };
export const fmtTime = (v) => { const d = toDate(v); return d ? format(d, "HH:mm") : ""; };
export const fmtAgo = (v) => { const d = toDate(v); return d ? formatDistanceToNowStrict(d, { locale: cs, addSuffix: true }) : ""; };
export const fmtMoney = (n) => (n || n === 0 ? new Intl.NumberFormat("cs-CZ", { style: "currency", currency: "CZK", maximumFractionDigits: 0 }).format(n) : "—");
export const fmtDue = (v) => {
  const d = toDate(v);
  if (!d) return { text: "—", cls: "text-gray-400" };
  if (isToday(d)) return { text: "Dnes", cls: "text-blue-600 font-medium" };
  if (isPast(d)) return { text: fmtDate(d), cls: "text-red-600 font-medium" };
  return { text: fmtDate(d), cls: "text-gray-600" };
};
export const toInputDate = (v) => { const d = toDate(v); return d ? format(d, "yyyy-MM-dd") : ""; };
export const todayInput = () => format(new Date(), "yyyy-MM-dd");

export const initials = (name = "") => name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]).join("").toUpperCase();

export const ROLE_LABELS = { admin: "Admin", manager: "Manažer", salesperson: "Obchodník", operator: "Operátor", support: "Support" };
export const TASK_STATUS_LABELS = { pending: "Čeká", in_progress: "Probíhá", completed: "Hotovo", cancelled: "Zrušeno", delegated: "Delegováno" };
export const CALL_RESULT_LABELS = { answered: "Dovoláno", not_answered: "Nedovoláno", busy: "Obsazeno", voicemail: "Hlasovka" };
export const MOOD = { positive: "😀", neutral: "😐", negative: "😟" };

export const priorityStyle = (p) => {
  if (p >= 9) return "bg-red-600 text-white";
  if (p >= 7) return "bg-gray-900 text-white";
  if (p >= 4) return "bg-gray-200 text-gray-800";
  return "bg-gray-100 text-gray-500";
};

export const fmtBytes = (b) => !b ? "0 B" : b < 1e6 ? `${Math.round(b / 1e3)} kB` : b < 1e9 ? `${(b / 1e6).toFixed(1)} MB` : `${(b / 1e9).toFixed(2)} GB`;
